<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div name="btn-block" class="simple-row clearfix">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="addPart(null)">新增部件</button>
                <button class="swb-btn swb-btn-small" @click="addPartFromAsmbl(null)">从组装件选择</button>
            </div>
        </div>
        <div name="hint-msg" class="hint block" v-if="!repairFlag">
            <p><span class="font-red">提示：仅需维修设备才可设置可维修操作</span></p>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { openDevcRelatedPartSaveDlg } from './selectDlg'
    import { showAsmblAccDefSelectDlg } from '../asmblAcc/dialog'

    import devcApi from '../../api/devc';

    export default {
        name: 'swb-devc-related-part-list',
        desc: '设备部件',
        props: {
            devcId: {
                type: Number,
                default: null
            },
            repairFlag: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                confKey: 'swb-devc-related-part-list',
                theTableHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 260,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                // 过滤信息
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 部件列表
                devcRelatedPartList: []
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
        },
        mounted() {
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'sellerType': function (row, colName, colValue, rowIndex) {
                        return '<span>' + self.merchantTypeMap[row.sellerType] + '</span>';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
//                        if(Utils.isTrue(self.repairFlag)) {
//                            btnList.push({
//                                name: 'set_repairable',
//                                text: '设置可维修'
//                            });
//                        }
                        btnList.push({
                            name: 'do_delete',
                            text: '移除'
                        });
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'set_repairable') {
                            // 设置可维修
                            self.setRepairable(row);
                        } else if(btnName == 'do_delete') {
                            // 移除
                            self.doDelete(row);
                        }
                    }
                });
            },
            //
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDevcRelatedPartList();
            },
            //
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDevcRelatedPartList();
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            getDevcRelatedPartList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if(!Utils.isNoB(self.devcId)) {
                    filterItems.devcId = self.devcId;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                devcApi.getDevcRelatedPartPageList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let devcRelatedPartList = result.data.rows || [];
                        self.devcRelatedPartList = Utils.merge([], devcRelatedPartList);
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(self.devcRelatedPartList, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 新增部件
            addPart: function () {
                let self = this;
                openDevcRelatedPartSaveDlg({}, function (devcPart, theDlg) {
                    devcPart.devcId = self.devcId;
                    //
                    let theLoading = MsgBox.loading();
                    //
                    devcApi.saveDevcRelatedPart(devcPart, function (result) {
                        theLoading.close();
                        if(result.type == 'info') {
                            theDlg.close();
                            MsgBox.success('操作成功！');
                            self.getDevcRelatedPartList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            // 从组装件选择
            addPartFromAsmbl: function () {
                let self = this;
                showAsmblAccDefSelectDlg({
                    checkBox: true
                }, function (accDefs, dlg) {
                    dlg.close();
                    accDefs = accDefs || [];
                    let devcPartList = [];
                    let devcPartNameList = [];
                    for(let i = 0; i < accDefs.length; i++) {
                        let accDef = accDefs[i];
                        let devcPart = {
                            devcId: self.devcId,
                            name: accDef.name,
                            memo: '从组装件添加来的'
                        };
                        if(!devcPartNameList.contains(devcPart.name)) {
                            devcPartList.push(devcPart);
                            devcPartNameList.push(devcPart.name);
                        }
                    }
                    //
                    let theLoading = MsgBox.loading();
                    //
                    devcApi.saveDevcRelatedParts(devcPartList, function (result) {
                        theLoading.close();
                        if(result.type == 'info') {
                            MsgBox.success('操作成功！');
                            self.getDevcRelatedPartList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            // 设置可维修
            setRepairable: function (row) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '设备部件 - 设置可维修',
                    showCloseBtn: true,
                    width: 450,
                    height: 200,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label class="required">可维修</label>' +
                    '</div>' +
                    '<div class="form-value width-1-5x">' +
                    '<el-radio-group v-model="repairable">' +
                    '<el-radio :label="true">是</el-radio>' +
                    '<el-radio :label="false">否</el-radio>' +
                    '</el-radio-group>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        repairable: row.repairable
                    },
                    okClicked: function () {
                        let postData = {
                            id: row.id,
                            repairable: this.repairable
                        };
                        let theLoad = MsgBox.loading();
                        devcApi.doDevcRelatedPartRepairable(postData, function (result) {
                            theLoad.hide();
                            if(result.type === "info") {
                                theDlg.close();
                                //
                                MsgBox.success("操作成功！");
                                self.getDevcRelatedPartList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            },
            // 移除
            doDelete: function (row) {
                let self = this;
                this.$confirm('确定要移除该部件吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: row.id
                    };
                    let theLoad = MsgBox.loading();
                    devcApi.doDeleteDevcRelatedPart(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            //
                            MsgBox.success("操作成功！");
                            self.getDevcRelatedPartList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devc/DevcRelatedPartList.vue